import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { NonContributableEmptyState } from "~/components/NonContributableNullState/NonContributableNullState";
import { useIsSearchActive } from "~/hooks/search/useIsSearchActive";
import { PublicBoardNoSearchResults } from "./PublicBoardNoSearchResults";
export const PublicBoardNullState = /*#__PURE__*/ memo(()=>{
    const { isSearchActive } = useIsSearchActive();
    if (isSearchActive) return /*#__PURE__*/ _jsx(PublicBoardNoSearchResults, {});
    return /*#__PURE__*/ _jsx(NonContributableEmptyState, {});
});
PublicBoardNullState.displayName = "PublicBoardNullState";
